/** Convert a date to an ISO string if it is not already a string. */
const dateToISOString = (date: number | string) =>
  typeof date === 'string' ? date : new Date(date).toISOString();
export default dateToISOString;
